const chartItemName = (item: any): string => {
    if (item.view_type === 'O') {
        return "作家";
    }
    if (item.item_id === 0) {
        return "全商品合計";
    }
    if (!item.page_name || item.item_name.startsWith(item.page_name)) {
        return item.item_name;
    }
    return item.page_name + " " + item.item_name;
};

export default chartItemName;